export function points(config) {
  const xs = this.numbers(config);
  const ys = this.numbers(config);
  return xs.map((x, i) => ({ x, y: ys[i] }));
}

export function bubbles(config) {
  return this.points(config).map(pt => {
    pt.r = this.rand(config.rmin, config.rmax);
    return pt;
  });
}

export function labels(config) {
  var cfg = config || {};
  var min = cfg.min || 0;
  var max = cfg.max || 100;
  var count = cfg.count || 8;
  var step = (max - min) / count;
  var decimals = cfg.decimals || 8;
  var dfactor = Math.pow(10, decimals) || 0;
  var prefix = cfg.prefix || '';
  var values = [];
  var i;

  for (i = min; i < max; i += step) {
    values.push(prefix + Math.round(dfactor * i) / dfactor);
  }

  return values;
}

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export function months(config) {
  var cfg = config || {};
  var count = cfg.count || 12;
  var section = cfg.section;
  var values = [];
  var i, value;

  for (i = 0; i < count; ++i) {
    value = MONTHS[Math.ceil(i) % 12];
    values.push(value.substring(0, section));
  }

  return values;
}

const COLORS = [
  '#4dc9f6',
  '#f67019',
  '#f53794',
  '#537bc4',
  '#acc236',
  '#166a8f',
  '#00a950',
  '#58595b',
  '#8549ba'
];

export function color(index) {
  return COLORS[index % COLORS.length];
}


export const CHART_COLORS = {
  red: 'rgb(255, 99, 132)',
  orange: 'rgb(255, 159, 64)',
  yellow: 'rgb(255, 205, 86)',
  green: 'rgb(75, 192, 192)',
  blue: 'rgb(54, 162, 235)',
  purple: 'rgb(153, 102, 255)',
  brown: 'rgb(127, 79, 50)',
  pink: 'rgb(255, 192, 203)',
  dgreen: 'rgb(0, 153, 76)',
  dpurple: 'rgb(153, 51, 102)',
  lyellow: 'rgb(255, 235, 170)',
  lgreen: 'rgb(153, 255, 204)',
  lblue: 'rgb(153, 204, 255)',
  cyan: 'rgb(0, 255, 255)',
  teal: 'rgb(0, 128, 128)',
  olive: 'rgb(128, 128, 0)',
  peach: 'rgb(255, 218, 185)',
  maroon: 'rgb(128, 0, 0)',
  dcyan: 'rgb(0, 127, 127)',
  dteal: 'rgb(0, 63, 63)',
  dolive: 'rgb(63, 63, 0)',
  dpeach: 'rgb(255, 172, 145)',
  dmaroon: 'rgb(63, 0, 0)'
};

export const NAMED_COLORS = [
  CHART_COLORS.red,
  CHART_COLORS.blue,
  CHART_COLORS.yellow,
  CHART_COLORS.green,
  CHART_COLORS.orange,
  CHART_COLORS.purple,
  CHART_COLORS.brown,
  CHART_COLORS.pink,
  CHART_COLORS.dgreen,
  CHART_COLORS.dpurple,
  CHART_COLORS.lyellow,
  CHART_COLORS.lgreen,
  CHART_COLORS.lblue,
  CHART_COLORS.cyan,
  CHART_COLORS.teal,
  CHART_COLORS.olive,
  CHART_COLORS.peach,
  CHART_COLORS.maroon,
  CHART_COLORS.dcyan,
  CHART_COLORS.dteal,
  CHART_COLORS.dolive,
  CHART_COLORS.dmaroon,
  CHART_COLORS.dpeach
];

export function namedColor(index) {
  return NAMED_COLORS[index % NAMED_COLORS.length];
}
